import ActionUtility from "../../utilities/ActionUtility";
import IAction from "../../models/IAction";
import FeedbackTypeEnum from "../../constants/FeedbackTypeEnum";
import FeedbackModel from "./models/FeedbackModel";
import { v4 as uuidv4 } from "uuid";
import FeedbackOperationEnum from "constants/FeedbackOperationEnum";

export default class FeedbackAction {
    public static readonly FEEDBACK_ADD: string = "OperationFeedbackAction.FEEDBACK_ADD";
    public static readonly FEEDBACK_DELETE: string = "OperationFeedbackAction.FEEDBACK_DELETE";
    public static readonly FEEDBACK_CLEAN: string = "OperationFeedbackAction.FEEDBACK_CLEAN";

    public static add(
        type: FeedbackTypeEnum,
        operation: FeedbackOperationEnum,
        message: string,
        description?: string
    ): IAction<FeedbackModel> {
        return ActionUtility.createAction(
            FeedbackAction.FEEDBACK_ADD,
            new FeedbackModel({
                id: uuidv4(),
                type,
                operation,
                message,
                description,
            })
        );
    }

    public static delete(feedbackId: string): IAction<string> {
        return ActionUtility.createAction(FeedbackAction.FEEDBACK_DELETE, feedbackId);
    }

    public static clean(): IAction<undefined> {
        return ActionUtility.createAction(FeedbackAction.FEEDBACK_CLEAN);
    }
}
